// Servicio para manejo de medicina preventiva (vacunas y desparasitaciones)
import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  orderBy,
  getFirestore 
} from 'firebase/firestore';
import app from '../config/firebase';

const db = getFirestore(app);

// Servicios para VACUNAS
export const vacunasService = {
  // Crear nueva vacuna
  createVacuna: async (vacunaData) => {
    try {
      console.log('💉 Creando nueva vacuna:', vacunaData);
      
      const vacunaCompleta = {
        ...vacunaData,
        fechaCreacion: new Date(),
        estado: 'activa'
      };
      
      const docRef = await addDoc(collection(db, 'vacunas'), vacunaCompleta);
      console.log('✅ Vacuna creada con ID:', docRef.id);
      
      return {
        success: true,
        id: docRef.id,
        data: { ...vacunaCompleta, id: docRef.id }
      };
    } catch (error) {
      console.error('❌ Error creando vacuna:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Obtener vacunas por paciente
  getVacunasByPaciente: async (pacienteId) => {
    try {
      console.log('🔍 Buscando vacunas para paciente:', pacienteId);
      
      const q = query(
        collection(db, 'vacunas'),
        where('pacienteId', '==', pacienteId),
        orderBy('fechaAplicacion', 'desc')
      );
      
      const querySnapshot = await getDocs(q);
      const vacunas = [];
      
      querySnapshot.forEach((doc) => {
        vacunas.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      console.log('✅ Vacunas encontradas:', vacunas.length);
      return {
        success: true,
        data: vacunas
      };
    } catch (error) {
      console.error('❌ Error obteniendo vacunas:', error);
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  },

  // Actualizar vacuna
  updateVacuna: async (vacunaId, vacunaData) => {
    try {
      console.log('✏️ Actualizando vacuna:', vacunaId);
      
      const vacunaRef = doc(db, 'vacunas', vacunaId);
      const datosActualizados = {
        ...vacunaData,
        fechaActualizacion: new Date()
      };
      
      await updateDoc(vacunaRef, datosActualizados);
      console.log('✅ Vacuna actualizada correctamente');
      
      return {
        success: true,
        data: { ...datosActualizados, id: vacunaId }
      };
    } catch (error) {
      console.error('❌ Error actualizando vacuna:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Eliminar vacuna
  deleteVacuna: async (vacunaId) => {
    try {
      console.log('🗑️ Eliminando vacuna:', vacunaId);
      
      await deleteDoc(doc(db, 'vacunas', vacunaId));
      console.log('✅ Vacuna eliminada correctamente');
      
      return {
        success: true
      };
    } catch (error) {
      console.error('❌ Error eliminando vacuna:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};

// Servicios para DESPARASITACIONES
export const desparasitacionesService = {
  // Crear nueva desparasitación
  createDesparasitacion: async (desparasitacionData) => {
    try {
      console.log('🐛 Creando nueva desparasitación:', desparasitacionData);
      
      const desparasitacionCompleta = {
        ...desparasitacionData,
        fechaCreacion: new Date(),
        estado: 'activa'
      };
      
      const docRef = await addDoc(collection(db, 'desparasitaciones'), desparasitacionCompleta);
      console.log('✅ Desparasitación creada con ID:', docRef.id);
      
      return {
        success: true,
        id: docRef.id,
        data: { ...desparasitacionCompleta, id: docRef.id }
      };
    } catch (error) {
      console.error('❌ Error creando desparasitación:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Obtener desparasitaciones por paciente
  getDesparasitacionesByPaciente: async (pacienteId) => {
    try {
      console.log('🔍 Buscando desparasitaciones para paciente:', pacienteId);
      
      const q = query(
        collection(db, 'desparasitaciones'),
        where('pacienteId', '==', pacienteId),
        orderBy('fechaAplicacion', 'desc')
      );
      
      const querySnapshot = await getDocs(q);
      const desparasitaciones = [];
      
      querySnapshot.forEach((doc) => {
        desparasitaciones.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      console.log('✅ Desparasitaciones encontradas:', desparasitaciones.length);
      return {
        success: true,
        data: desparasitaciones
      };
    } catch (error) {
      console.error('❌ Error obteniendo desparasitaciones:', error);
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  },

  // Actualizar desparasitación
  updateDesparasitacion: async (desparasitacionId, desparasitacionData) => {
    try {
      console.log('✏️ Actualizando desparasitación:', desparasitacionId);
      
      const desparasitacionRef = doc(db, 'desparasitaciones', desparasitacionId);
      const datosActualizados = {
        ...desparasitacionData,
        fechaActualizacion: new Date()
      };
      
      await updateDoc(desparasitacionRef, datosActualizados);
      console.log('✅ Desparasitación actualizada correctamente');
      
      return {
        success: true,
        data: { ...datosActualizados, id: desparasitacionId }
      };
    } catch (error) {
      console.error('❌ Error actualizando desparasitación:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Eliminar desparasitación
  deleteDesparasitacion: async (desparasitacionId) => {
    try {
      console.log('🗑️ Eliminando desparasitación:', desparasitacionId);
      
      await deleteDoc(doc(db, 'desparasitaciones', desparasitacionId));
      console.log('✅ Desparasitación eliminada correctamente');
      
      return {
        success: true
      };
    } catch (error) {
      console.error('❌ Error eliminando desparasitación:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};

// Servicio combinado para medicina preventiva
export const medicinaPreventiva = {
  vacunas: vacunasService,
  desparasitaciones: desparasitacionesService
};

export default medicinaPreventiva;